import $ from 'jquery';
console.log('www');
export default class Header {
    constructor(e, p) {
        this.$e = $(e);
        this.$p = $(p);
        if (this.$e.length && this.$p.length) this.init();
    }

    init() {
        $('.ham').on('click', () => {
            $('.ham, .header__left > ul').toggleClass('active');
            if ($('.ham').hasClass('active')) {
                // this.$e.css('margin-top', this.$p.height() * -1 + 'px');
            } else {
                $(window).trigger('scroll');
            }
        });
        $('.ham').on('click', () => {
            // console.log("AAAAAAAAAA");
            $('.header__mobile-menu').toggleClass('active');
          });
        $('.menu-parent-1 > li.menu-item-has-children > a').each((i, e) => {
            // console.log('elo');
            const $e = $(e);
            $e.on('click', (x) => {
                if ($(window).width() > 920) return;
                if (!$e.hasClass('allowClick')) {
                    x.preventDefault();
                    $('.menu-parent-2 > li.menu-item-has-children > a').removeClass('allowClick');
                    $('.menu-parent-2 > li.menu-item-has-children > a').next().removeAttr('style');
                    const $n = $e.next();
                    // $n.css('height', $n[0].scrollHeight + 'px');
                    $n.addClass('active_sub');
                    $e.addClass('allowClick');
                }
            })
        });
        $('.menu-parent-2 > li.menu-item-has-children > a').each((i, e) => {
            const $e = $(e);
            $e.on('click', (x) => {
                if (!$e.hasClass('allowClick')) {
                    x.preventDefault(); 
                    $('.menu-parent-3 > li.menu-item-has-children > a').removeClass('allowClick');
                    $('.menu-parent-3 > li.menu-item-has-children > a').next().removeAttr('style');
                    const $n = $e.next();
                    $n.addClass('active_sub');
                    $e.addClass('allowClick');
                    $e.addClass('allowClick');
                    if ($(window).width() <= 920) {
                        setTimeout(() => {
                            let height = 0;
                            $e.parent().parent().children().each((i, e) => {
                                height += $(e).height() + 8;
                            });
                            // height = Math.min(height, $e.parent().parent()[0].scrollHeight);
                            $e.parent().parent().css('height', height + 'px');
                        }, 200);
                    }
                }
            })
        });
        const offsetMenu = () => {
            const offer = $('.menu-parent-1 > li:first-of-type .menu-parent-2');
            if ($(window).width() < 920) {
                offer.removeAttr('style');
            } else {
                // offer.css('margin-left', Math.min((offer.width() + offer[0].offsetLeft - $(window).width()) * -1, 0) + 'px');
            }
        };
        $(window).on('resize', () => {
            offsetMenu();
            $('.menu-parent-2 > li.menu-item-has-children > a').removeClass('allowClick');
            $('.menu-parent-2 > li.menu-item-has-children > a').next().removeAttr('style');
            $('.menu-parent-3 > li.menu-item-has-children > a').removeClass('allowClick');
            $('.menu-parent-3 > li.menu-item-has-children > a').next().removeAttr('style');
        });
        $(window).trigger('resize');
        $('.menu-parent-1 [href="#"]').removeAttr('href');
    }
}
$('.fc__imgbox').on('click', function(){
    $('.fc__info').toggleClass('active');
});
$('.fc__info--exit').on('click', function(){
    $('.fc__info').removeClass('active');
});
$('.t1__top--item').on('click', function(){
    $('.t1__top--item').removeClass('active');
    $(this).addClass('active');
    $('.t1__bot--box').removeClass('active');
    var thisdata = $(this).data('ttop');

    $('html, body').animate({
        scrollTop: $('.t1__bot').offset().top - 150
  }, 500, 'linear');
    
    $('.t1__bot--box').each(function(){
        var boxdata = $(this).data('ttop');
        if (thisdata == boxdata){
            $(this).addClass('active');
        }
        

    });
});
$('.swiat__item').on('click', function(){
    $('.swiat__item').removeClass('active');
    $(this).addClass('active');
    $('.t1__content--row').removeClass('active');
    $('.swiat__description').removeClass('active');
    var thisdata = $(this).data('swiat');

    $('html, body').animate({
        scrollTop: $('.t1__bot').offset().top - 150
  }, 500, 'linear');
    
    $('.t1__content--row').each(function(){
        var boxdata = $(this).data('swiat');
        if (thisdata == boxdata){
            $(this).addClass('active');
        }
    });
    $('.swiat__description').each(function(){
        var boxdata1 = $(this).data('swiat');
        if (thisdata == boxdata1){
            $(this).addClass('active');
        }
    });
});